<template>
<div>

  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Schedule</el-breadcrumb-item>
    <el-breadcrumb-item>Schedule Update History</el-breadcrumb-item>
  </el-breadcrumb>
</el-col>
  <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    <!-- Updating Time: {{ this.updateTime }} -->
    </el-col>
  </el-row>
  <!--卡片视图区域-->

  <el-card>
    <el-form  :model="formInline" class="demo-form-inline">
      <el-row>
        <el-col :span = "7">
      <el-form-item label="Brand:" label-width="100px">
        <el-select v-model="formInline.brands" multiple collapse-tags
              style="margin-left: 0px;"  filterable
              placeholder="please choose">
            <el-option
            v-for="item in brandList"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      </el-col>
      <el-col :span = "7">
        <el-form-item label="Item:" label-width="100px">
          <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span = "10">
        <el-form-item label="PO Date:" label-width="90px">
        <el-date-picker
              v-model="formInline.poDate"  value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="-"
              start-placeholder="Start Date"
              end-placeholder="End Date">
            </el-date-picker>
      </el-form-item>
      </el-col>
      </el-row>
      <el-row>
      <el-col :span = "7">
        <el-form-item label="Project Id:" label-width="100px">
          <el-input v-model="formInline.projectId" placeholder="Project Id" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span = "7">
        <el-form-item label="Order No.:" label-width="100px">
          <el-input v-model="formInline.orderNo" placeholder="Order No." clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span = "10">
        <el-form-item label="Export Date:" label-width="90px">
          <el-date-picker
                v-model="formInline.date"  value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="Start Date"
                end-placeholder="End Date">
              </el-date-picker>
        </el-form-item>
      </el-col>
      <!-- <el-col :span = "10">
          <el-form-item  style="margin-left: 90px;">
          <el-button type="primary" @click="onSubmit">Search</el-button>
          <el-button type="primary" @click="exportToExcel">Excel</el-button>
          </el-form-item>
      </el-col> -->
      </el-row>
      <el-row>
        <el-col>
        <el-form-item style="margin-left: 450px;">
          <el-button type="primary" @click="onSubmit">Search</el-button>
          <el-button type="primary" @click="exportToExcel">Excel</el-button>
        </el-form-item>
        </el-col>
      </el-row>
    </el-form>

      <!-- Schedule 列表区域 -->
      <el-table :data="yachList" border stripe style="width: 100%">
        <el-table-column type="expand" fixed>
              <template slot-scope="props">
                <el-form inline class="demo-table-expand" border>
                  <el-row>
                   <el-col :span="6"><el-form-item label="Sch. Date 1" prop="schDate1" value-format="yyyy-MM-dd">
                    <span>{{ dateFormat1(props.row.schDate1) }}</span>
                  </el-form-item>
                   </el-col>
                   <el-col :span="15">
                   <el-form-item label="Sch. QTY1">
                                       <span>{{ numFormat1(props.row.schQty1) }}</span>
                                     </el-form-item>
                                       </el-col>
                  </el-row>

                  <el-row>
                   <el-col :span="6"><el-form-item label="Sch. Date 2">
                    <span>{{ dateFormat1(props.row.schDate2) }}</span>
                  </el-form-item>
                   </el-col>
                   <el-col :span="15">
                   <el-form-item label="Sch. QTY2">
                                       <span>{{ numFormat1(props.row.schQty2) }}</span>
                                     </el-form-item>
                                       </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Sch. Date 3">
                                        <span>{{ dateFormat1(props.row.schDate3) }}</span>
                                      </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Sch. QTY3">
                                                            <span>{{ numFormat1(props.row.schQty3) }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="sch. Date 4">
                      <span>{{ dateFormat1(props.row.schDate4) }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Sch. QTY4">
                                                            <span>{{ numFormat1(props.row.schQty4) }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Status">
                      <span>{{ props.row.status }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Comment">
                                                            <span>{{ props.row.comment }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Type">
                      <span>{{ props.row.type }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Prod. Date">
                                                            <span>{{ dateFormat1(props.row.prodDate) }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Prod. QTY">
                      <span>{{ props.row.prodQty }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Stage 1">
                                                            <span>{{ props.row.stage1 }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Date Stage1">
                      <span>{{ dateFormat1(props.row.dateStage1) }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="QTY Stage1">
                                                            <span>{{ numFormat1(props.row.qtyStage1) }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Stage 2">
                      <span>{{ props.row.stage2 }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Date Stage2">
                                                            <span>{{ dateFormat1(props.row.dateStage2) }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="QTY Stage2">
                      <span>{{ props.row.qtyStage2 }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Stage 3">
                                                            <span>{{ props.row.stage3 }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Date Stage3">
                      <span>{{ dateFormat1(props.row.dateStage3) }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="QTY Deco3">
                                                            <span>{{ numFormat1(props.row.qtyDeco3) }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Change Date">
                      <span>{{ dateFormat1(props.row.changeDate) }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Buyer">
                                                            <span>{{ props.row.buyer }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Category">
                      <span>{{ props.row.category }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="SPL Room Position">
                                                            <span>{{props.row.splRoomPosition }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Delivery address">
                      <span>{{ props.row.deliveryAddr }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Line Closed">
                                                            <span>{{ lineConversion(props.row.lineClosed) }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Delivery Priority">
                      <span>{{ props.row.deliveryPriority }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Incotern Town">
                                                            <span>{{ props.row.incotermTown }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Ship-to Customer Name">
                      <span>{{ props.row.shipCustomerNm }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Delivery Address">
                                                            <span>{{ props.row.deliveryAddrDesc }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Post City Country">
                      <span>{{ props.row.postCityCountry }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Weekly Output">
                                                            <span>{{ numFormat1(props.row.zwekOutpQty) }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                </el-form>
              </template>
            </el-table-column>

        <el-table-column type="index" fixed label="#"></el-table-column>
        <el-table-column fixed
          prop="createTime"  :formatter="dateFormat"
          label="Export Date"
          width="100">
        </el-table-column>
        <el-table-column fixed
          prop="id"
          label="ID"
          width="150">
        </el-table-column>
            <el-table-column fixed
              prop="brand"        :formatter="dropNull"
              label="Brand"         sortable
              width="80">
            </el-table-column>
            <el-table-column fixed
              prop="projectId"      sortable
              label="Project ID"
              width="120">
            </el-table-column>

            <el-table-column
              prop="project"    :show-overflow-tooltip="true"
              label="Project"           sortable
              width="120">
            </el-table-column>

            <el-table-column
              prop="supplier"            sortable
              label="Supplier" :show-overflow-tooltip="true"
              width="100">
            </el-table-column>

            <el-table-column
              prop="poNum"    :show-overflow-tooltip="true"
              label="PO #"         sortable
              width="120">
            </el-table-column>

            <el-table-column
              prop="orderNo"         sortable        :formatter="dropNull"
              label="Order no."      :show-overflow-tooltip="true"
              width="120">
            </el-table-column>

            <el-table-column
              prop="item"          :show-overflow-tooltip="true"
              label="Item"         sortable
              width="100">
            </el-table-column>

            <el-table-column
              prop="description"  :show-overflow-tooltip="true"
              label="Description"
              width="160">
            </el-table-column>

            <el-table-column
              prop="capacity"    :show-overflow-tooltip="true"        :formatter="dropNull"
              label="Capacity"         sortable
              width="100">
            </el-table-column>

            <el-table-column
              prop="j3pNum"         sortable
              label="J3P #" :show-overflow-tooltip="true"
              width="120">
            </el-table-column>

            <el-table-column
              prop="poDate"  :formatter="dateFormat"
              label="PO Date"         sortable
              width="100">
            </el-table-column>

            <el-table-column
              prop="reqDeliveryDate"  :formatter="dateFormat"
              label="Req. Delivery Date"         sortable
              width="139">
            </el-table-column>

            <el-table-column
              prop="j3pRequired"  :formatter="dateFormat"             :sort-method="sortByj3pRequired"
              label="J3P Required"         sortable
              width="130">
            </el-table-column>

            <el-table-column
              prop="spcRequired"  :formatter="dateFormat"
              label="SPC Required"         sortable
              width="130">
            </el-table-column>

            <el-table-column
              prop="delay"         sortable
              label="Delay"
              width="80">
            </el-table-column>

            <el-table-column
              prop="orderQty"         sortable
              label="order QTY"
              width="110">
            </el-table-column>

            <el-table-column
              prop="delivered"         sortable
              label="Delivered"
              width="110">
            </el-table-column>

            <el-table-column
              prop="numOfReceipt"         sortable
              label="Number of receipts"
              width="170">
            </el-table-column>

            <el-table-column
              prop="lastReceiptDt"  :formatter="dateFormat"
              label="Last Receipt Date"         sortable
              width="160">
            </el-table-column>

            <el-table-column
              prop="balance"         sortable
              label="Balance"
              width="100">
            </el-table-column>
            <el-table-column
              prop="isNew"         sortable
              label="New"        :formatter="dropNull"
              width="90">
            </el-table-column>

            <el-table-column
              prop="line"
              label="Line"
              width="65">
            </el-table-column>
          </el-table>

          <!-- 分页区域-->
          <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination> -->
  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        brands: [],
        item: '',
        projectId: '',
        orderNo: '',
        poDate: '',
        date: '',
        token: '',
        page: 1,
        rows: 100
      },
      userName: '',
      yachList: [],
      brandList: [],
      total: 0,
      updateTime: '',
      poDateStart: '',
      poDateEnd: '',
      dateStart: '',
      dateEnd: '',
      brandParam: {
        userName: '',
        userType: ''
      }

    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.getYachs()
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getBrands()
  },
  methods: {
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getYachs()
    },
    exportToExcel () {
      /* 表示在当前页面打开新地址 https://www.myirequest.com */
      window.open('https://www.myirequest.com:8081/show/exportYachUpdateHistory?token=' + encodeURIComponent(this.formInline.token) + '&brands=' + this.formInline.brands + '&projectId=' + this.formInline.projectId +
      '&item=' + this.formInline.item + '&orderNo=' + this.formInline.orderNo + '&poDate=' + this.formInline.poDate + '&date=' + this.formInline.date, '_parent')
    },
    async getYachs () {
      var brandsStr = ''
      this.poDateStart = ''
      this.poDateEnd = ''
      this.dateStart = ''
      this.dateEnd = ''

      if (this.formInline.poDate) {
        if (this.formInline.poDate.length) {
          this.poDateStart = this.formInline.poDate[0]
          this.poDateEnd = this.formInline.poDate[1]
          this.formInline.poDate = [...this.formInline.poDate].join(',')
        }
      }
      if (this.formInline.poDate === null) {
        this.formInline.poDate = ','
      }
      // console.log('222222 === ' + this.formInline.date)
      if (this.formInline.date) {
        // console.log('this.formInline.date.length=== ' + this.formInline.date.length)
        if (this.formInline.date.length) {
          this.dateStart = this.formInline.date[0]
          this.dateEnd = this.formInline.date[1]
          this.formInline.date = [...this.formInline.date].join(',')
        }
      }
      if (this.formInline.date === null) {
        this.formInline.date = ','
      }
      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandsStr = this.formInline.brands
      }
      const { data: res } = await this.$http.get('/show/yachUpdatesHistoryList', { params: this.formInline })
      this.yachList = res.rows
      // console.log('this.yachList.length === ' + this.yachList.size())
      this.total = res.total
      /* if (res.rows && this.yachList[0]) {
        this.updateTime = this.yachList[0].createTime
      } */
      await this.$set(this.formInline, 'poDate', [this.poDateStart, this.poDateEnd])
      await this.$set(this.formInline, 'date', [this.dateStart, this.dateEnd])
      // console.log('this.formInline.date111 === ' + this.formInline.date)
      // console.log('this.formInline.poDate111 === ' + this.formInline.poDate)

      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }
    },
    nullFormatBlank (row, column, cellValue, index) {
      const daterc = row[column.property]
      // console.log('daterc111===' + daterc)
      if (daterc === 'null' || daterc === null) {
        return ''
      }
    },
    lineConversion (value) {
      if (value === '0') {
        return 'Yes'
      } else if (value === '1') {
        return 'No'
      } else {
        return ''
      }
    },
    dateFormat1 (daterc) {
      // const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }

      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    numFormat1 (numrc) {
      // var numrc = row[column.property]
      if (numrc === null || numrc === '') {
        return
      }
      var result = ''
      var counter = 0

      numrc = (numrc || 0).toString()
      for (var i = numrc.length - 1; i >= 0; i--) {
        counter++
        result = numrc.charAt(i) + result
        if (!(counter % 3) && i !== 0) {
          result = ' ' + result
        }
      }
      return result
    },
    numFormat (row, column, cellValue, index) {
      var numrc = row[column.property]
      if (numrc === null || numrc === '') {
        return
      }
      var result = ''
      var counter = 0

      numrc = (numrc || 0).toString()
      for (var i = numrc.length - 1; i >= 0; i--) {
        counter++
        result = numrc.charAt(i) + result
        if (!(counter % 3) && i !== 0) {
          result = ' ' + result
        }
      }
      return result
    },
    dropNull (row, column, cellValue, index) {
      var numrc = row[column.property]
      if (numrc === null || numrc === '') {
        return
      }
      if (numrc === 'null') {
        return ''
      }
      return numrc
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getYachs()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getYachs()
    },
    getMonth (month) {
      var monthLetter
      switch (month) {
        case '01':
          monthLetter = 'Jan'
          break
        case '02':
          monthLetter = 'Feb'
          break
        case '03':
          monthLetter = 'Mar'
          break
        case '04':
          monthLetter = 'Apr'
          break
        case '05':
          monthLetter = 'May'
          break
        case '06':
          monthLetter = 'Jun'
          break
        case '07':
          monthLetter = 'Jul'
          break
        case '08':
          monthLetter = 'Aug'
          break
        case '09':
          monthLetter = 'Sep'
          break
        case 10:
          monthLetter = 'Oct'
          break
        case 11:
          monthLetter = 'Nov'
          break
        case 12:
          monthLetter = 'Dec'
          break
      }
      return monthLetter
    },
    sortByj3pRequired (obj1, obj2) {
      var val1 = Math.floor(new Date(obj1.j3pRequired).getTime() / 1000)
      var val2 = Math.floor(new Date(obj2.j3pRequired).getTime() / 1000)
      return val1 - val2
    }

  }
}
</script>

<style>
</style>
